































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import UpdateAccountStateRequest from '@/models/Accounts/Shared/UpdateAccountStateRequest';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import AccountState from "@/models/Accounts/Shared/AccountState";
import ProductSubType from '@/models/Products/ProductSubType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'AccountStateEditDialog' })
export default class extends SaascadaVueDialog {

    request: UpdateAccountStateRequest = new UpdateAccountStateRequest();
    hasStateChanged: boolean = false;

    CustomerAccountState = AccountState;

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountStateRequest();
            this.request.state = DepositAccountModule.depositAccount.state;
            this.hasStateChanged = false;
        }
    }

    async updateHasStateChanged() {
        // Check if the state has changed set the flag to show the extra fields and make sure they are cleared
        this.hasStateChanged = this.request.state !== DepositAccountModule.depositAccount.state;
        this.request.accountStateReasonCode = undefined;
        this.request.accountStateReasonDescription = '';
    }

    get accountStateOptions() {
        return ListUtils.accountStateOptions();
    }

    get isAccountClosed() {
        // Check if account is closed as closed accounts cannot be editted
        return DepositAccountModule.depositAccount.state === AccountState.Closed;
    }

    get accountStateReasonOptions() {
        // Show different account state options depending on the product sub type
        if (DepositAccountModule.depositAccount.productSubType === ProductSubType.DepositFixedTerm) {
            return ListUtils.accountStateReasonOptionsForFixedTerm();
        }
        else {
            return ListUtils.accountStateReasonOptions();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // No need to make the API call if the account state hasn't changed
            if (this.hasStateChanged) {
                await DepositAccountModule.updateDepositAccountState(this.request);
            }
        }
    }

}
